import React from "react";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

const MigaPan = ({ breadcrumbs = [] }) => {
  if (breadcrumbs.length === 0) return null;

  return (
    <>
    <Box sx={{ marginBottom: 2 }}>
      <Breadcrumbs aria-label="breadcrumb">
        {breadcrumbs.map((breadcrumb, index) => {
          const isLast = index === breadcrumbs.length - 1;
          return isLast ? (
            <Typography
              key={index}
              sx={{
                color: "primary.main",
                fontWeight: "bold",
                fontSize: "inherit",
              }}
            >
              {breadcrumb.label}
            </Typography>
          ) : (
            <Link
              key={index}
              underline="hover"
              href={breadcrumb.href}
              sx={{
                color: "primary.main",
                fontWeight: "bold",
                fontSize: "inherit",
              }}
            >
              {breadcrumb.label}
            </Link>
          );
        })}
      </Breadcrumbs>
      <Box
        sx={{
          width: "75%",
          height: "2px",
          backgroundColor: "primary.main",
          mt: 1, // Margen superior
        }}
      />
      </Box>
    </>
  );
};

export default MigaPan;
